<div class="fleetcard-tos-banner success">
  <div class="content">
    {{tosConfig.bannerTitle}} &nbsp;&nbsp;
    <button
      class="secondary-btn"
      phx-button
      [phxButtonRole]="'secondary'"
      [phxButtonType]="'default'"
      [phxBackground]="'medium'"
      [phxSize]="'small'"
      (phxOnClick)="handleSecondaryCTAClick()"
    >
      {{tosConfig.bannerSecondaryBtnText}}
    </button>
    <button
      class="ml-10"
      phx-button
      [phxButtonRole]="'primary'"
      [phxButtonType]="'default'"
      [phxBackground]="'standard'"
      [phxSize]="'small'"
      (phxOnClick)="handlePrimaryCTAClick()"
    >
      {{tosConfig.bannerPrimaryBtnText}}
    </button>
  </div>
</div>